"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const CardRenderItemComponent_vue_1 = require("@/client/components/card/CardRenderItemComponent.vue");
const CardRenderSymbolComponent_vue_1 = require("@/client/components/card/CardRenderSymbolComponent.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'CardProductionBoxComponent',
    props: {
        rows: {
            type: Array,
            required: true,
        },
    },
    components: {
        CardRenderItemComponent: CardRenderItemComponent_vue_1.default,
        CardRenderSymbolComponent: CardRenderSymbolComponent_vue_1.default,
    },
    methods: {
        getClasses() {
            const classes = ['card-production-box'];
            return classes.join(' ');
        },
    },
});
